import React, { useState } from "react";
import alfredoIcon from "../../assets/alfredo-central-icon.png";
import styled, { keyframes } from "styled-components";
import MessageBox from "../../components/MessageBox";
import { useCombinedStore } from "../../store";
import { useNavigate } from "react-router-dom";
import * as AlfredoStyles from "../../styles/global/global";

interface LogoProps {
  $selectedSession: string;
  $isLoading: boolean;
}

const logoAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const Logo = styled.img<LogoProps>`
  width: ${(props) => (props.$isLoading ? "calc(var(--u) * 300)" : "calc(var(--u) * 150)")};
  height: ${(props) => (props.$isLoading ? "calc(var(--u) * 300)" : "calc(var(--u) * 150)")};
  opacity: ${(props) => (props.$isLoading ? 0 : 1)};
  z-index: 1;
  animation: ${(props) => (props.$isLoading ? logoAnimation : "none")} 2s linear
    forwards;
  animation-delay: 1s;
`;

interface RegisterPageProps {
  children: React.ReactElement;
}

const expandLeftAnimation = keyframes`
  0% {
    flex: 0.1;
  }
  100% {
    flex: 1;
  }
`;

const Left = styled(AlfredoStyles.Left)<{ isLoading: boolean }>`
  animation: ${(props) => (props.isLoading ? expandLeftAnimation : "none")} 3s
    forwards;
`;

const RegisterPage: React.FC<RegisterPageProps> = ({ children }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { selectedSection, userName } = useCombinedStore((state) => {
    return {
      selectedSection: state.selectedSectionZustand || "Email",
      userName: state.registerDataZustand.userName,
    };
  });

  const handleRegister = () => {
    setIsLoading(true);
  };

  return (
    <AlfredoStyles.SignPageContainer>
      <MessageBox />
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
      />
      <AlfredoStyles.SignUp>
        <AlfredoStyles.SignUpText>
          Sua loja já está no Alfredo?
        </AlfredoStyles.SignUpText>
        <AlfredoStyles.SignUpButton onClick={() => navigate("/login")}>
          <i className="material-icon">login</i>ACESSAR AGORA
        </AlfredoStyles.SignUpButton>
      </AlfredoStyles.SignUp>
      <Left isLoading={isLoading}>
        <Logo
          src={alfredoIcon}
          alt="Alfredo Icon"
          $selectedSession={selectedSection}
          $isLoading={isLoading}
        />
        <AlfredoStyles.SignPageTitle $isLoading={isLoading}>
          Bem vindo ao Alfredo
        </AlfredoStyles.SignPageTitle>
        {isLoading && (
          <AlfredoStyles.WelcomeText className="loading">
            Bem vindo, {userName}
          </AlfredoStyles.WelcomeText>
        )}
        <AlfredoStyles.DescriptionText>
          A Inteligência Artificial das Lojas Físicas.
        </AlfredoStyles.DescriptionText>
      </Left>
      {!isLoading && (
        <AlfredoStyles.Right>
          <AlfredoStyles.ModalContent>
            {React.cloneElement(children, { setIsLoading: handleRegister })}
          </AlfredoStyles.ModalContent>
        </AlfredoStyles.Right>
      )}
    </AlfredoStyles.SignPageContainer>
  );
};

export default RegisterPage;
